/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import find from 'lodash/find'
import Graphql from '@/services/Graphql'
import HttpProvider from '@/services/HttpProvider'
import Logger from '@/services/Logger'
import Config from 'config'
import { restWithCache } from '@/store/lib/search'
import { fillToPad } from 'theme/helpers'
// import { manageAttributesLabel } from '@/helpers/utils'

export default {
  makeSearch (ctx, { inputText, pagination, dispatchToDo }) {
    if (dispatchToDo) {
      return ctx.dispatch(dispatchToDo, { inputText, pagination })
        .then((res) => {
          return res
        })
    }
  },
  searchProduct (ctx, { inputText }) {
    // reuse productQuery if searchCriteria is "product"
    inputText = fillToPad(inputText, 9)
    return Graphql.genericCallCash({
      token: ctx.rootState.user.token,
      storeViewCode: ctx.rootState.ui.storeViewCode,
      graphSchemaType: 'suggestionsProduct',
      variables: { inputText: `${inputText.toUpperCase()}` }
    })
      .then(resp => {
        if (resp && resp.data && resp.data.products) {
          resp.data.products.categoryAggregations = find(resp.data.products.aggregationsStore, { attribute_code: 'category_id' })
          return resp.data.products
        }
        return {}
      })
      .catch(err => {
        Logger.error(err)
        return []
      })
  },
  searchCustomer (ctx, { inputText }) {
    // start splitting input text
    /**
     * split inputText by space
     * in this way we suppose that
     * first part of string if first name
     * last part is lastname
     * in case of email or cardNumber not space will be provided
     */
    if (!inputText) {
      return Promise.resolve([])
    }
    let fist = ''
    let last = ''
    if (/\s/g.test(inputText)) {
      let splitname = inputText.split(' ')
      fist = splitname[0]
      last = splitname[splitname.length - 1]
    }
    let searchCriteria = `searchCriteria[filter_groups][0][filters][0][field]=email&
    searchCriteria[filter_groups][0][filters][0][value]=${inputText}&
    searchCriteria[filter_groups][0][filters][0][condition_type]=like&
    searchCriteria[filter_groups][0][filters][1][field]=first_name&
    searchCriteria[filter_groups][0][filters][1][value]=${fist || inputText}&
    searchCriteria[filter_groups][0][filters][1][condition_type]=like&
    searchCriteria[filter_groups][0][filters][2][field]=last_name&
    searchCriteria[filter_groups][0][filters][2][value]=${last || inputText}&
    searchCriteria[filter_groups][0][filters][2][condition_type]=like&
    searchCriteria[filter_groups][0][filters][3][field]=c_cardNumber&
    searchCriteria[filter_groups][0][filters][3][value]=${inputText}`
    let query = Config.API.search.customers.replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode).replace('searchCriteria', searchCriteria)
    return restWithCache({
      query,
      restPromise: HttpProvider.get(query, {
        headers: {
          'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
        }
      })
    })
      .then(res => {
        return res
      })
  },
  searchOrders (ctx, { inputText, pagination }) {
    let searchCriteria = `searchCriteria[filter_groups][1][filters][0][field]=order_no&
    searchCriteria[filter_groups][1][filters][0][value]=${inputText}&
    searchCriteria[filter_groups][1][filters][0][condition_type]=like&
    searchCriteria[filter_groups][1][filters][1][field]=customer_email&
    searchCriteria[filter_groups][1][filters][1][value]=${inputText}&
    searchCriteria[filter_groups][1][filters][1][condition_type]=like&
    searchCriteria[sortOrders][0][field]=order_no&
    searchCriteria[sortOrders][0][direction]=desc&`

    if (pagination) {
      searchCriteria += `searchCriteria[currentPage]=${pagination.page}&`
      searchCriteria += `searchCriteria[pageSize]=${pagination.size}`
    } else {
      searchCriteria += `searchCriteria[pageSize]=${Config.Theme.searchSuggestions.ordersLimit}`
    }
    let query = Config.API.search.orders.replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode).replace('searchCriteria', searchCriteria)
    return restWithCache({
      query,
      restPromise: HttpProvider.get(query, {
        headers: {
          'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
        }
      })
    })
      .then(res => {
        return res
      })
  },
  async searchStores (ctx, { inputText, hasCoordinates = false }) {
    inputText = inputText.toLowerCase()
    if ((global.google || window.google) && (inputText || hasCoordinates)) {
      const geocoder = new window.google.maps.Geocoder()
      let coordinates = hasCoordinates || await geocoder.geocode({ 'address': inputText })
        .then((res) => {
          if (res.results && res.results.length) {
            return {
              lat: res.results[0]['geometry'].location.lat(),
              lng: res.results[0]['geometry'].location.lng()
            }
          } else {
            return false
          }
        })
      return ctx.dispatch('storeLocator/getBoutiqueByLocations', { coordinates, enable: true }, { root: true })
        .then((stores) => {
          return stores || []
        })
    }

    // filter by stores already loaded
    let stores = await ctx.dispatch('storeLocator/getStorePickup', null, { root: true })
      .then((res) => {
        return res
      })

    return stores
  },
  searchProductEan (ctx, { ean }) {
    let query = Config.API.search.productEan
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
    return HttpProvider.post(query,
      {
        ean
      },
      {
        headers: {
          'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
        }
      })
      .then(res => {
        if ('data' in res) {
          return res.data
        } else {
          return res
        }
      })
  }
}
